import { render, staticRenderFns } from "./CorporatePodcast.vue?vue&type=template&id=a7b8016a&scoped=true"
import script from "./CorporatePodcast.vue?vue&type=script&lang=js"
export * from "./CorporatePodcast.vue?vue&type=script&lang=js"
import style0 from "./CorporatePodcast.vue?vue&type=style&index=0&id=a7b8016a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b8016a",
  null
  
)

export default component.exports